function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  id: "icon-emob_svg__a",
  d: "M0 0h100v100H0z"
}));

var _ref2 =
/*#__PURE__*/
React.createElement("clipPath", {
  id: "icon-emob_svg__b"
}, React.createElement("use", {
  xlinkHref: "#icon-emob_svg__a",
  overflow: "visible"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M80.04 26.44A40.698 40.698 0 0191 54.29C91 76.77 72.86 95 50.5 95S10 76.77 10 54.29c0-21.77 16.99-39.55 38.37-40.66M31.32 75.71h8.53v-6.43h-8.53v6.43h0zm29.84 0h8.53v-6.43h-8.53v6.43h0zm12.79-6.42V56.43l-8.52-4.29H35.58l-8.52 4.29v12.86h46.89zM61.16 39.28H39.84l-4.26 12.86h29.84l-4.26-12.86h0zM27.05 60.71h10.66-10.66 0zm36.24 0h10.66-10.66 0zM48.37 22.14h17.05V5H48.37v17.14h0zM65.42 9.29h8.52-8.52 0zm0 8.57h8.52-8.52 0z",
  clipPath: "url(#icon-emob_svg__b)",
  fill: "none",
  stroke: "#fff",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10
});

function SvgIconEmob(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 100 100"
  }, props), _ref, _ref2, _ref3);
}

export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDIzLjAuNiwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkViZW5lXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCAxMDAgMTAwIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCAxMDAgMTAwOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+CgkKCQkuc3Qwe2NsaXAtcGF0aDp1cmwoI1NWR0lEXzJfKTtmaWxsOm5vbmU7c3Ryb2tlOiNGRkZGRkY7c3Ryb2tlLXdpZHRoOjI7c3Ryb2tlLWxpbmVjYXA6cm91bmQ7c3Ryb2tlLWxpbmVqb2luOnJvdW5kO3N0cm9rZS1taXRlcmxpbWl0OjEwO30KPC9zdHlsZT4KPGc+Cgk8Zz4KCQk8ZGVmcz4KCQkJPHJlY3QgaWQ9IlNWR0lEXzFfIiB4PSIwIiB5PSIwIiB3aWR0aD0iMTAwIiBoZWlnaHQ9IjEwMCIvPgoJCTwvZGVmcz4KCQk8Y2xpcFBhdGggaWQ9IlNWR0lEXzJfIj4KCQkJPHVzZSB4bGluazpocmVmPSIjU1ZHSURfMV8iICBzdHlsZT0ib3ZlcmZsb3c6dmlzaWJsZTsiLz4KCQk8L2NsaXBQYXRoPgoJCTxwYXRoIGNsYXNzPSJzdDAiIGQ9Ik04MC4wNCwyNi40NEM4Ni44MywzMy43Miw5MSw0My41MSw5MSw1NC4yOUM5MSw3Ni43Nyw3Mi44Niw5NSw1MC41LDk1UzEwLDc2Ljc3LDEwLDU0LjI5CgkJCWMwLTIxLjc3LDE2Ljk5LTM5LjU1LDM4LjM3LTQwLjY2IE0zMS4zMiw3NS43MWg4LjUzdi02LjQzaC04LjUzVjc1LjcxTDMxLjMyLDc1LjcxeiBNNjEuMTYsNzUuNzFoOC41M3YtNi40M2gtOC41M1Y3NS43MQoJCQlMNjEuMTYsNzUuNzF6IE03My45NSw2OS4yOVY1Ni40M2wtOC41Mi00LjI5SDM1LjU4bC04LjUyLDQuMjl2MTIuODZINzMuOTVMNzMuOTUsNjkuMjl6IE02MS4xNiwzOS4yOEgzOS44NGwtNC4yNiwxMi44NmgyOS44NAoJCQlMNjEuMTYsMzkuMjhMNjEuMTYsMzkuMjh6IE0yNy4wNSw2MC43MWgxMC42NkgyNy4wNUwyNy4wNSw2MC43MXogTTYzLjI5LDYwLjcxaDEwLjY2SDYzLjI5TDYzLjI5LDYwLjcxeiBNNDguMzcsMjIuMTRoMTcuMDVWNQoJCQlINDguMzdWMjIuMTRMNDguMzcsMjIuMTR6IE02NS40Miw5LjI5aDguNTJINjUuNDJMNjUuNDIsOS4yOXogTTY1LjQyLDE3Ljg2aDguNTJINjUuNDJMNjUuNDIsMTcuODZ6Ii8+Cgk8L2c+CjwvZz4KPC9zdmc+Cg==";
export { SvgIconEmob as ReactComponent };